export const handleFormInput = (e, payload) => {
  const { name, value } = e.target;

  if (!name || name.trim() === "") return payload;

  return {
    ...payload,
    [name]: value,
  };
};


export const handleFormNumericInput = (e, payload) => {
  return { ...payload, [e.target.name]: parseInt(e.target.value) };
}

export const handleFormRadio = (e, payload) => {
  return { ...payload, [e.target.name]: parseInt(e.target.value) };
}

export const handleFormCheckbox = (e, payload) => {
  return { ...payload, [e.target.name]: e.target.checked ? true : false };
}

export const handleFormMultiSelect = (e, payload) => {
  let options = e.target.options, value = [];
  for (let i = 0, l = options.length; i < l; i++) {
    if (options[i].selected) {
      value.push(parseInt(options[i].value));
    }
  }
  return { ...payload, [e.target.name]: value };
}


export const handleDateChange = (e) => {
  const date = new Date(e.target.value);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
  const year = String(date.getFullYear()).slice(2); // Get the last two digits of the year

  // Format the date as DDMMYY
  const formatted = `${day}${month}${year}`;
  return formatted;
};

export const onInputChange = (input) => {
  let { value, maxLength } = input.target;
  if (value.length > maxLength) {
    input.target.value = value.slice(0, maxLength);
  }
};

// Decode text safely before rendering
export const decodeHtmlEntities = (text) => {
  if (!text) return "";
  const textarea = document.createElement("textarea");
  textarea.innerHTML = text;
  return textarea.value;
};

export const cleanInvalidChars = (text) => {
  return text.replace(/[^\x00-\x7F]+/g, ""); // remove weird symbols
};